// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const defaultForm = {
  code: '',
  display_name: '',
  short_name: '',
  description: '',
  active: true,
  concession_commerce_id: '63882e1dbb7e036a8ee93fe5'
}

const initialState = {
  data: [],
  statePagination: false,
  showModal: false,
  isUpdate: false,
  areaForm: defaultForm,
  updateForm: defaultForm
}

export const superadminAreaSlice = createSlice({
  name: 'superadminArea',
  initialState,
  reducers: {
    setAreas: (state, action) => {
      state.data = action.payload.items
      state.statePagination = action.payload.nextPageExists
    },
    setOpenModal: (state, action) => {
      state.showModal = action.payload
    },
    setArea: (state, action) => {
      state.updateForm = action.payload
    },
    setUpdate: (state, action) => {
      state.isUpdate = action.payload
    }
  }
})

export const { setAreas, setOpenModal, setArea, setUpdate } =
  superadminAreaSlice.actions

export const superadminArea = superadminAreaSlice.reducer
